import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { Field, reduxForm } from 'redux-form';

import { getCurriculumLibrariesDetails, saveCurriculumLibraries } from './actions/CurriculumLibrariesActions';
import { renderCheckBox, renderTextField } from '../../../components/reduxFields';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../components/buttons';
import SmallLoader from '../../../img/small-loader.gif';
import validate from './validate';
import { checkFieldExistence, clearFieldErrorArray } from '../../../modules/AppConfig/actions';
import { MODULE } from './constants/ApiConstants';
import { displayCustomError } from '../../../../src/actions/utilAction';



class CurriculumLibrariesModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      curriculumLibrariesId: props.curriculumLibrariesId
    };
  }

  componentWillMount() {
    if (this.state.curriculumLibrariesId) {
      this.props.getCurriculumLibrariesDetails(this.state.curriculumLibrariesId);
    }
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.open) {
      this.props.clearFieldErrorArray();
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };

  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ? (
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  onSubmitHandler(formProps) {
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    let postData = {
      "id": this.props.curriculumLibrariesId || 0,
      "libraryName": formProps.libraryName,
      "isActive":  formProps.isActive || false
    }
    this.props.clearFieldErrorArray();
    this.props.saveCurriculumLibraries(postData);
    this.setState({ open: false });
    this.props.closeDialog();
  }

  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': this.state.curriculumLibrariesId || 0,
      };
      this.props.checkFieldExistence(postData);
    }
  };

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  };

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
    <SubmitButtonModalDisabled label="Loading" /> :
    <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
    const actions = [
        <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
        submitButton,
      ];
    return (
      <Dialog
        className="custom_modal"
        title={
          this.state.curriculumLibrariesId
            ? "Edit Curriculum Library"
            : "Add Curriculum Library"
        }
        modal={false}
        open={this.state.open}
        actions={actions}
        autoScrollBodyContent={true}
      >
        {this.renderLoading()}
        <div className="row">
          <div className="col-sm-12">
            <form
              className="readmin-form custom_form"
              onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}
            >
              <div className="row">
                <div className="col-sm-12 require">
                  <Field
                    autoFocus={true}
                    name="libraryName"
                    type="text"          
                    onChange={(input, value) => this.checkFieldDataExistence(input, value, 'Curriculum library name')}
                    customError={displayCustomError('LIBRARYNAME', this.props.fieldError)}        
                    maxLength="250"
                    label="Curriculum Library Name"
                    // normalize={isValidNameWithSpace}
                    component={renderTextField}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3">
                  <Field
                    className="mt20 mb0"
                    name="isActive"
                    label="Is Active"
                    component={renderCheckBox}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    );
  }
}

CurriculumLibrariesModal = reduxForm({
    form: 'CurriculumLibrariesModalForm',
    validate,
    enableReinitialize: true,
})(CurriculumLibrariesModal);


function mapStateToProps(state, ownProps) { 

  let initialValueData = {
    isActive: true,
  };
  if (ownProps.curriculumLibrariesId && state.curriculumLibraries.curriculumLibrariesListDetails) {
    initialValueData = state.curriculumLibraries.curriculumLibrariesListDetails.data || null;
  } 

  return {
    loading: state.curriculumLibraries.loading,
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    initialValues: initialValueData,
  }
}

export default connect(mapStateToProps,{getCurriculumLibrariesDetails, checkFieldExistence, clearFieldErrorArray, saveCurriculumLibraries})(CurriculumLibrariesModal);



// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/curriculumLibraries/curriculumLibraries_Modal.js